import FastImage from 'react-native-fast-image';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';

export const Container = styled.View`
  border-style: solid;
  border-top-width: 1px;
  border-color: ${({theme}) => theme.colors.border};
`;

export const Item = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: ${RFValue(50)}px;
  padding: 0 24px;
`;

export const Infos = styled.View`
  flex-direction: row;
  align-items: center;
`;


//@ts-ignore
export const CreditCardBrandImage = styled(FastImage)`
  width: ${RFValue(20)}px;
  height: ${RFValue(13)}px;
  margin-right: ${RFValue(12)}px;
`;

export const PaymentInfo = styled.View`
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const PaymentTitles = styled.View`
  flex-direction: row;
  align-items: flex-end;
`;

export const PaymentTitle = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.medium};
`;

export const CardAlert = styled.View``;

export const CardAlertIcon = styled(Feather)`
  font-size: ${RFValue(20)}px;
  color: ${({theme}) => theme.colors.attention};
`;

export const SelectIconContainer = styled.View``;

export const SelectIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const PromoCard = styled.Text`
  font-size: ${RFValue(9)}px;
  background-color: ${({theme}) => theme.colors.brbButton};
  color: ${({theme}) => theme.colors.shape};
  padding:0 4px;
  border-radius: 5px;
  overflow: hidden;
  font-family: ${({theme}) => theme.fonts.bold};
`;